// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import appealDeadlineEntity from './entities/appeal-deadline.json';
import appealDeadlineMenu from '../pages/appeal-deadline/menu.json';
import appealDeadlineFullForm from '../pages/appeal-deadline/forms/full.json';
import appealDeadlineContextForm from '../pages/appeal-deadline/forms/context.json';
import appealDeadlineMiniForm from '../pages/appeal-deadline/forms/mini.json';
import appealDeadlineLookupForm from '../pages/appeal-deadline/forms/lookup.json';
import appealDeadlineTableView from '../pages/appeal-deadline/views/table.json';
import appealDeadlineCardsView from '../pages/appeal-deadline/views/cards.json';
import appealDeadlineCalendarView from '../pages/appeal-deadline/views/calendar.json';
import appealDeadlineDashboardView from '../pages/appeal-deadline/views/dashboard.json';

/** Тип запису «Строк відповіді» зі сторінками пакета: меню, форми та подання з pages/appeal-deadline/. */
export const appealDeadlineDefinition: IRecordTypeDefinition = {
  ...appealDeadlineEntity,
  views: assembleViewSet({
      table: appealDeadlineTableView,
      cards: appealDeadlineCardsView,
      calendar: appealDeadlineCalendarView,
      dashboard: appealDeadlineDashboardView,
  }),
  form: appealDeadlineFullForm,
  forms: { full: appealDeadlineFullForm, context: appealDeadlineContextForm, mini: appealDeadlineMiniForm, lookup: appealDeadlineLookupForm },
  menu: appealDeadlineMenu,
} as IRecordTypeDefinition;
